/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartItemSchema } from "./banquetCartItemSchema.ts";

export const banquetCartComboGroupSchema = z.object({
	id: z.uuid(),
	item: banquetCartItemSchema,
});
